import estilos from './DetalleDeCompraComponent.module.css'
import React, { useState, Fragment } from 'react'
import moment from 'moment'
import BotonVerArchivoComponent from './ComponenteFinanzas/BotonVerArchivoComponent'
import FinanzasComponent from './ComponenteFinanzas/FinanzasComponent'
import HologramaAdminComponent from './ComponenteHologramaAdmin/HologramaAdminComponent'
import { useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
const DetalleDeCompraComponent = (props) => {

    const detalle = useSelector(store => store.ModuloCompras.fc_40Detalle)
    
    const dataUser = useSelector(store => store.Usuario.user)


    return (
        <div className='container2 mt-5 text-center row'>
            <FinanzasComponent detalleCompra={detalle} /><br />
            {dataUser?.[0]?.idtipousuario == 9 &&
                <HologramaAdminComponent detalleCompra={detalle} />
            }
        </div>
    );

};

export default withRouter(DetalleDeCompraComponent)
